import React from "react";
var __jsx = React.createElement;
import stl from "./ArrowType2SVG.module.css";
var ArrowType2SVG = function ArrowType2SVG(_ref) {
  var _ref$filledColor = _ref.filledColor,
    filledColor = _ref$filledColor === void 0 ? "#154F9C" : _ref$filledColor,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    id = _ref.id;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
    id: id,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    onClick: onClick,
    className: "".concat(stl.ArrowType2SVG, " ").concat(className ? className : "")
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7099 15.88L10.8299 12L14.7099 8.11998C15.0999 7.72998 15.0999 7.09998 14.7099 6.70998C14.3199 6.31998 13.6899 6.31998 13.2999 6.70998L8.70994 11.3C8.31994 11.69 8.31994 12.32 8.70994 12.71L13.2999 17.3C13.6899 17.69 14.3199 17.69 14.7099 17.3C15.0899 16.91 15.0999 16.27 14.7099 15.88Z",
    fill: filledColor
  })));
};
export default ArrowType2SVG;